module.exports = __webpack_public_path__ + "img/coordinated-uncoordinated-attack2.a0890789.png";